import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { AuthService } from '../../../services-http/auth/auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';



@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  recoveryEmail:any =''
  update:any = false;
  createNewPasswordForm!: FormGroup;
   
    constructor(
      private spinner: NgxSpinnerService,
      private authService: AuthService,
      private fb: FormBuilder,
      private router: Router,

    ) { }

    ngOnInit() {

      this.createNewPasswordForm = this.fb.group({
        email: [this.recoveryEmail, [Validators.required, Validators.email]], // Email validation
        newPassword: ['', [Validators.required, Validators.minLength(6)]], // Min length 6
        confirmPassword: ['', [Validators.required]], // Must match newPassword
        code: ['', [Validators.required]], 
      });
     }


    forgotPasswordSend(){

      let recoveryEmail = {
        username: this.recoveryEmail,
        update:false
      }
  
      this.authService.forgotPasswordSend(recoveryEmail).subscribe(res =>{

        this.update = true;
      
      },error=>{
        let err=error.error;
        let msg='';
  
        Object.keys(err).forEach(function(key){
          msg+=err[key]+'<br/>';
        })
  
        Swal.fire(
          'Oppss!',
          msg,
          'error'
        );
      });  
    }



      updatePassword(){
        this.spinner.show();
    
        let data = {
          username: this.createNewPasswordForm.get('email').value,
          password: this.createNewPasswordForm.get('newPassword').value,
          password_confirmation: this.createNewPasswordForm.get('confirmPassword').value,
          verification_code: this.createNewPasswordForm.get('code').value,
          update: true
        }
    
        this.authService.forgotPasswordSend(data).subscribe(res=>{
          this.spinner.hide();

          this.createNewPasswordForm.reset();

          Swal.fire(
            'Success',
            res['msg'],
            'success'
          );
          
        },error=>{
          this.spinner.hide();
    
          let err=error.error;
          let msg='';
    
          Object.keys(err).forEach(function(key){
            msg+=err[key]+'<br/>';
          })
    
          Swal.fire(
            'Oppss',
            msg,
            'error'
          );
        });
         
      }

      backToLogin(){
        this.router.navigateByUrl('/welcome/home');
      }

  

}
